var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-body-1"},[_vm._v("Перенаправление на страницу заказа...")])}
var staticRenderFns = []

export { render, staticRenderFns }